<template>
  <b-modal ref="modal" hide-footer centered title="Template info">
    <b-form @submit.prevent="save">
      <b-form-group label="Preview image:">
        <b-form-file
          v-model="img"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
        <div
          v-if="imgBase64"
          class="templateInfoImg"
        >
          <b-img
            thumbnail
            fluid
            :src="imgBase64"
            alt="Image 1"
          />
          <a
            href="#"
            class="templateInfoImg__remove"
            @click.prevent="imgBase64 = null"
          >
            <icon name="remove" />
          </a>
        </div>
      </b-form-group>
      <b-form-group label="Description:">
        <b-form-textarea v-model="desc" placeholder="Enter description..." rows="4" />
      </b-form-group>
      <b-button variant="success" type="submit">Save</b-button>
    </b-form>
  </b-modal>
</template>

<script>
// services
import db from '@/services/db'

export default {
  data() {
    return {
      img: null,
      imgBase64: null,
      desc: null,
    }
  },
  watch: {
    img(val) {
      const toBase64 = file =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = error => reject(error)
        })

      if (val) toBase64(val).then((img) => this.imgBase64 = img)
    }
  },
  methods: {
    open() {
      if (this.$refs.modal) this.$refs.modal.show()
    },
    close() {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    async save() {
      db.getRef('templateDescription')
        .set({
          img: this.imgBase64,
          desc: this.desc
        }, () => {
          this.close()
        })
    },
  },
  created() {
    db.getRef('templateDescription')
      .on('value', snapshot => {
        const { desc, img } = snapshot.val() || {}

        this.imgBase64 = img || null
        this.desc = desc || null
      })
  },
  beforeDestroy() {
    db.getRef('templateDescription')
      .off('value')
  }
}
</script>

<style lang="scss">
.templateInfoImg {
  position: relative;
  max-width: 250px;
  margin-top: 10px;
  &__remove {
    position: absolute;
    right: 12px;
    top: 12px;
    color: white !important;
    background: #f5365c;
    line-height: 1px;
    padding: 2px 3px;
    border-radius: 3px;
    &:hover,
    &:focus {
      background: lighten($color: #f5365c, $amount: 5);
    }
  }
}
</style>
